const resetPasswordForm = document.getElementById("wc_user_reset_password");

if( resetPasswordForm ) {
    let btnResetPassword = document.getElementById('btn-reset-password');
    
    btnResetPassword.addEventListener("click", function (event) {
        event.preventDefault();
        
        let password = document.getElementById('password_1').value;
        let confirmPassword = document.getElementById('password_2').value;

        document.querySelectorAll('.error').forEach(element => {
            element.remove();
        });
        
        if( (password.length > 0) && (confirmPassword.length > 0) ) {
            if( password === confirmPassword ) {
                resetPasswordForm.submit();
            } else {
                afrigar_message_element_input_validate('password_2', 'error', 'Password do not match');
            }
            
        } else {
            if( password.length < 1 ) {
                afrigar_message_element_input_validate('password_1', 'error', 'Password is required');
            }
            
            if( confirmPassword.length < 1 ) {
                afrigar_message_element_input_validate('password_2', 'error', 'Password is required');
            }
        }

    });
}